import styled from 'styled-components';

export const StyledOutletHeader = styled.div<{ backgroundColor: string }>`
  background-color: ${({ backgroundColor }): string => backgroundColor};
  box-sizing: border-box;
  width: 100%;
  padding: ${({ theme }): string => theme.spacing_unit_x2};

  & > a,
  & > button {
    padding: 0;
  }

  & > img {
    max-width: 130px;
    height: 130px;
    width: 100%;
    margin-left: auto;
    display: block;
    margin-bottom: ${({ theme }): string => theme.spacing_unit_x1};
  }
`;
